import { render, staticRenderFns } from "./ProductTemplateList.vue?vue&type=template&id=6a9ca371&"
import script from "./ProductTemplateList.vue?vue&type=script&lang=js&"
export * from "./ProductTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports